import { useEffect, type RefObject } from 'react'

/**
 * Вызывает `handler`, когда указатель нажат вне элемента `ref`.
 * @param ref - элемент, клик вне которого считается «снаружи»
 * @param handler - что делать при клике снаружи (напр. закрыть модалку)
 * @param enabled - включён ли слушатель (по умолчанию true)
 */
export const useOutsideClick = <T extends HTMLElement>(
  ref: RefObject<T>,
  handler: () => void,
  enabled = true,
) => {
  useEffect(() => {
    if (!enabled) return
    const onPointerDown = (e: PointerEvent) => {
      const el = ref.current
      if (el && !el.contains(e.target as Node)) handler()
    }
    document.addEventListener('pointerdown', onPointerDown)
    return () => document.removeEventListener('pointerdown', onPointerDown)
  }, [ref, handler, enabled])
}
